<app-resource-subtitle></app-resource-subtitle>
<div class="row">
    <div class="lp-background col d-flex flex-column-reverse flex-wrap align-items-end">
        <app-resource-details
            class="resource-details"
            [overviewTemplateRef]="overviewTemplate"
            [procedureTemplateRef]="procedureTemplate"
        >
        </app-resource-details>
        <div class="export-controls">
            <iframe
                id="lesson_plan_html_content"
                width="0"
                height="0"
                style="display: none"
            ></iframe>
            <ng-container
                [ngTemplateOutlet]="exportControls"
                *ngIf="!windowSize.isSmallDevice"
            ></ng-container>
        </div>
    </div>
</div>
<div class="row-auto">
    <div class="export-controls-mobile ms-4 ms-sm-0">
        <ng-container
            [ngTemplateOutlet]="exportControls"
            *ngIf="windowSize.isSmallDevice"
        ></ng-container>
    </div>
    <ng-container *ngIf="!isAddonView">
        <app-curriculum-tags class="ms-4 ms-sm-0"></app-curriculum-tags>
        <app-more-from-collection class="w-100"></app-more-from-collection>
    </ng-container>
</div>

<ng-template #overviewTemplate>
    <div class="d-flex" style="margin-top: 38px">
        <div class="col ps-1 overview-column">
            <div class="row">
                <div class="col-xs-12 col-sm-12 col-md-12 col-lg-9 resource-description">
                    <p [innerHtml]="resource.description | bypassSecurity: 'html'"></p>
                    <span *ngIf="resource.shouldShowContentWarnings">
                        <p>{{ resource.getSensitiveWarning() }}</p>
                    </span>
                </div>
                <ng-container
                    [ngTemplateOutlet]="creditsTemplate"
                    *ngIf="windowSize.isDesktop"
                ></ng-container>
            </div>
            <app-support-material-panel
                style="margin-bottom: 20px"
                [resource]="resource"
                *ngIf="windowSize.isSmallDesktop"
            ></app-support-material-panel>
            <div *ngFor="let overviewItem of resource.lessonData.overviewData">
                <h4 class="section-title">{{ overviewItem.label }}</h4>
                <p
                    class="overview-wrapper"
                    [innerHtml]="overviewItem.value | bypassSecurity: 'html'"
                ></p>
            </div>
            <ng-container
                [ngTemplateOutlet]="creditsTemplate"
                *ngIf="windowSize.isSmallDesktop"
            ></ng-container>
        </div>
        <app-support-material-panel
            [resource]="resource"
            *ngIf="windowSize.isDesktop"
        ></app-support-material-panel>
    </div>
</ng-template>
<ng-template #procedureTemplate>
    <div style="display: flex; margin-top: 38px">
        <div class="col procedure-column">
            <div *ngFor="let procedureItem of resource.lessonData.procedureData">
                <h4 class="section-title">{{ procedureItem.label }}</h4>
                <p
                    class="procedure-wrapper"
                    [innerHtml]="procedureItem.value | bypassSecurity: 'html'"
                ></p>
            </div>
        </div>
        <app-support-material-panel
            [resource]="resource"
            *ngIf="windowSize.isDesktop"
        ></app-support-material-panel>
    </div>
</ng-template>
<ng-template #creditsTemplate>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-3">
        <a
            *ngIf="resource.brand && resource.brand.getLogo()"
            class="brand-logo gtm-brand-logo selenium-brand-logo"
            [attr.data-gtmlabel]="resource.brand.name"
            [routerLink]="'/search'"
            [queryParams]="{
                q: '',
                selected_facet: 'brand:' + resource.brand.name,
            }"
        >
            <img src="{{ resource.brand.getLogo() }}" alt="{{ resource.brand.name }}" />
        </a>
        <div *ngIf="resource.contentFlags?.length" class="caution">
            <span class="caution-label">Caution</span>
            <p>Contains {{ resource.contentFlags }}</p>
        </div>

        <app-link
            *ngIf="resource?.creditsLink"
            [href]="resource?.creditsLink"
            class="mt-6 selenium-resource-credits {{ gtmPrefix }}-credits"
            target="_blank"
            >Credits</app-link
        >
    </div>
</ng-template>
<ng-template #exportControls>
    <app-button
        id="export-word"
        style="padding-right: 15px"
        buttonClasses="selenium-export-word gtm-export-word"
        [gtmLabel]="window.location.href"
        (click)="prepareAndDownloadDoc($event)"
    >
        <app-icon type="Document"></app-icon>
        <span>Export</span>
    </app-button>
    <a id="download-word" style="display: none"></a>
    <app-button
        buttonClasses="selenium-print-lessonplan gtm-print-lessonplan"
        aria-label="Print Lesson Plan"
        (click)="printLessonPlan()"
        [gtmLabel]="window.location.href"
    >
        <app-icon type="Print"></app-icon>
        <span>Print</span>
    </app-button>
</ng-template>
